import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import "./SendCodeModal.scss";
import alerts from "../utils/validations";
import PersonalizeCard from "../../services/PersonalizeCard";

const Container = styled.div`
  color: #162b92;
  font-weight: bold;
  font-size: small;
`;
const Text = styled.div`
  padding-inline: 1.5em;
  margin-bottom: 1.5em;
`;
const TRed = styled.span`
  color: #c00000;
`;
const Title = styled.h4`
  font-size: 1em;
  text-align: center;
  color: #162b92;
  font-weight: bolder;
  margin-bottom: 0;
`;

const UnregisteredUser = ({ listaCards, isActive, setFormEnviarCodigo, setRegistrarUsuario, setGuardarCodigo, setGuardarCorreo, setGuardarTeléfono, handleLimpiar }) => {
  const [validateEmail, setValidateEmail] = useState(false);
  const [validateCode, setValidateCode] = useState(false);
  const [phone2, setPhone2] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [internalCode, setInternalCode] = useState();
  const [enterCode, setEnterCode] = useState("");
  const [isErrorCode, setIsErrorCode] = useState(false);
  const [email2, setEmail2] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setGuardarCorreo(email2);
    setValidateEmail(true);
    setGuardarTeléfono(phone2);

    const form = event.currentTarget;
    if (form.checkValidity() === true){
      PersonalizeCard.generarOtp(listaCards[0].id_tarjeta, email2, phone2)
      .then((response) => {
        if (response.en == 1) {
          setShowModal(true);
        } else {
            alerts.warningAlert(
              "No se han encontrado datos.",
              "Validación "+response.validado+ "."
            );
        }
      })
      .catch((error) => {
        alerts.warningAlert(
          "No se ha generado el OTP.",
          ":(."
        );
      });
    }
    // if(isErrorCode)

  };

  const handleSubmitModal = (event) => {
    setValidateCode(true);
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();

    } else {
      event.preventDefault();
      event.stopPropagation();
      PersonalizeCard.validarOtp(listaCards[0].id_tarjeta, enterCode)
      .then((response) => {
        if (response.en == 1) {
          setShowModal(false);
          setFormEnviarCodigo();
          setRegistrarUsuario();
        } else {
          setShowModal(true);
          setIsErrorCode(true);
        }
      })
      .catch((error) => {
        console.log("Error: ", error)
        // alerts.warningAlert(
        //   "Código otp incorrecto.",
        //   ":(."
        // );
          setIsErrorCode(true);
          setShowModal(true);
      });
    }
  };

  const handleValidateCode = (e) => {
    setEnterCode(e.target.value)
    setInternalCode(e.target.value);
    setGuardarCodigo(e.target.value);
    setIsErrorCode(false)
  }

  const handleCloseModal = () => {
    setShowModal(false);
    setEnterCode("");
    setValidateCode(false);
  };
  const UseInput = ({
    id,
    value,
    onBlur,
    type = "text",
    placeholder,
    className = "input-lineal",
    pattern,
    feedback,
  }) => {
    return (
      <Form.Group controlId={`Form-${id}`}>
        <Form.Control
          onBlur={(e) => onBlur(e.target.value)}
          defaultValue={value}
          type={type}
          //required
          placeholder={placeholder}
          className={className}
          pattern={pattern}
          autoComplete="off"
        />
        <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>
      </Form.Group>
    );
  };
  return (
    isActive && (
      <Container>
        <Text>
          <TRed>Número de DNI no encontrado.</TRed>
        </Text>
        <Text>
          Si deseas continuar ingresa tu <TRed>correo</TRed> para enviarte un{" "}
          <TRed>código de registro.</TRed>
        </Text>
        <div>
          <Form noValidate validated={validateEmail} onSubmit={handleSubmit}>
            <Form.Group controlId="validationEmail">
              <Form.Control
                className="input-lineal"
                type="email"
                placeholder="Ingrese un correo electrónico"
                pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$"
                onBlur={(e) => setEmail2(e.target.value)}
                required
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese un email válido.
              </Form.Control.Feedback>
              <Form.Control.Feedback type="valid">
                Email válido.
              </Form.Control.Feedback>
            </Form.Group>
            {/* <UseInput
              id="phone"
              value={phone2}
              onBlur={setPhone2}
              placeholder="Teléfono..."
              pattern="\d{7,}"
              feedback="Ingrese un teléfono válido"
            /> */}
            <div className="text-center">
              <button className="btn btn-primary" type="submit" value="Submit">
                Enviar código
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                onClick={(e) => handleLimpiar(e)}
              >
                Limpiar
              </button>
            </div>
          </Form>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          data={""}
          size="4em"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          className="modalSendCode"
        >
          <Form
            noValidate
            validated={validateCode}
            onSubmit={handleSubmitModal}
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                <Title>¿Deseas continuar?</Title>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body
              scrollable="true"
              style={{
                maxHeight: "calc(100vh - 210px)",
                overflowY: "auto",
                paddingInline: "12%",
              }}
            >
              <Form.Group controlId="validationCode">
                <Form.Control
                  className="input-lineal"
                  type="text"
                  placeholder="Ingresa tu código... "
                  pattern="\d{5,}"
                  onChange={(e) => handleValidateCode(e)}
                  style={{borderColor: isErrorCode ? '#c6201c': !enterCode ? '#dee2e6' : null, backgroundImage: !enterCode ? "none" : null}}
                  autoComplete="off"
                  required
                />
                <Form.Text className="text-muted">
                  Tu código ha sido enviado al email: <b>{email2}</b>
                </Form.Text>
                {enterCode && (<Form.Control.Feedback type="invalid">
                  <b>Por favor ingrese un código numérico. {`(Ej: 12345)`}</b>
                </Form.Control.Feedback>)}
                {isErrorCode && (
                  <Form.Control.Feedback type="valid">
                    <TRed><b>El código ingresado no coincide con el enviado al email.</b></TRed>
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-secondary"
                onClick={() => handleCloseModal()}
              >
                Cancelar
              </button>
              <button className="btn btn-primary" type="submit" value="Submit">
                Continuar
              </button>
            </Modal.Footer>
          </Form>
        </Modal>
      </Container>
    )
  );
};

export default UnregisteredUser;
